//#region IMPORT
import React, { useState, useRef, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
/** Services Import */
/** Components */
import TRA_CUSTOM_02 from './TRA_CUSTOM_02';
import TRA_CUSTOM_02_ApproverSelectModal from './TRA_CUSTOM_02_ApproverSelectModal';
import dayjs from 'dayjs';
import Commons from '../../../../Services/Common/Common';
import Global from '../../../../Services/Common/Global';
import { useDispatch, useSelector } from 'react-redux';
import useDelete from '../../../../hooks/useDeleteN';
import { showSnackbar } from '../../../../Reducer/SnackbarReducer';
import { closeLoading, showLoading } from '../../../../Reducer/LoadingReducer';
import { createInitial, mapParamsBySchema } from '../../../../util';
import { apiRequest } from '../../../../Services/Common/ApiRequest';
import { MemberInfoModal_Schema } from '../../../../Components/MemberInfoModal/MemberInfoModal_Schema';
import { TRA_CUSTOM_02_Schema } from './TRA_CUSTOM_02_Schema';
import {
  useDelete1,
  useDelete2,
  useSave1,
  useSave2,
  saveTraCustom02ApproverSign,
  saveTraCustom02ApproverReject,
  getTraCustom02ReturnHistory,
  useSearch1,
  useSearch2,
  useSearchCode,
  useCreateTraCustom02QrSession,
  useSearchTraCustom02SessionR2,
  useBindTraCustom02QrSession,
} from './TRA_CUSTOM_02_QUERY';
import TRA_CUSTOM_02_QrModal from './TRA_CUSTOM_02_QrModal';
import { useSave } from '../../../../hooks/useSaveN';
import useFileUpload from '../../../../hooks/useFileUpload';
import usePartialRefresh from '../../../../hooks/usePartialRefresh';

//#endregion

// 화면 MENU_ID
const SCREEN_MENU_ID = 'MultiTrainingPage';

const INPUTS = {
  tpmId: '',
  // 교육 단계별 선택값
  eduTypeCd: '', // 교육의 구분
  eduNmCd: '', // 교육명
  eduContentsCd: '', // 교육 내용
  // 기존 회의/교육 공통 필드
  eduDt: dayjs().format('YYYY-MM-DD'), //  교육일
  eduTm: '', // 교육시간 (텍스트 또는 코드)
  eduPlace: '', // 교육장소
  eduManager: '', // 교육담당자
  eduInstructorId: '', // 교육강사
  eduInstructorNm: '', // 교육강사명
  eduInstructorPosition: '', // 교육강사직책

  // 교육 대상 / 실시 / 미실시 (남)
  eduTargetMCnt: '', //  교육 대상자 수(남)
  eduExecMCnt: '', //  교육 실시자 수(남)
  eduNoExecMCnt: '', //  교육 미실시자 수(남)

  // 교육 대상 / 실시 / 미실시 (여)
  eduExecWCnt: '', //  교육 실시자 수(여)
  eduTargetWCnt: '', //  교육 대상자 수(여)
  eduNoExecWCnt: '', //  교육 미실시자 수(여)

  // 교육 미실시 사유
  eduNoExecReason1: '', //  교육 미실시 사유1
  eduNoExecReason2: '', //  교육 미실시 사유2
  eduNoExecReason3: '', //  교육 미실시 사유3

  // 업로드 파일 1 (사진 대지)
  eduImageFileName1: '', //  사진 대지 파일명1
  eduImageSaveName1: '', //  사진 대지 저장명1
  eduImageFilePath1: '', //  사진 대지 파일주소1

  // 업로드 파일 2 (사진 대지)
  eduImageFileName2: '', //  사진 대지 파일명2
  eduImageSaveName2: '', //  사진 대지 저장명2
  eduImageFilePath2: '', //  사진 대지 파일주소2

  significant: '', //  특이사항

  selfYn: 'N',
};

/** 그리드/API 행에 tpmId · TpmId · TPM_ID 등으로 내려올 수 있음 */
function resolveTraCustom02TpmId(row) {
  if (!row || typeof row !== 'object') return '';
  const v = row.tpmId ?? row.TpmId ?? row.TPM_ID ?? '';
  const s = v != null ? String(v).trim() : '';
  return s;
}

function TRA_CUSTOM_02F(props) {
  //#region 변수
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userInfo, lanInfo } = useSelector((state) => state.BaseInfo);
  const searchInfo = useSelector((state) => state.SearchInfo);
  const [codes, setCodes] = useState({});
  //로그 관련
  const [rowData1, setRowData1] = useState([]); //그리드 데이터
  const [selectedRowData1, setSelectedRowData1] = useState([]);
  const [changedRowData1, setChangedRowData1] = useState([]);
  const [deletedRowData1, setDeletedRowData1] = useState([]);
  const selectedRowNosRef = useRef(new Set());
  const lastCheckedIndexRef = useRef(null);
  const currentRowIndexRef = useRef(null);
  const gridRef1 = useRef(); //교육일지 그리드

  // 모달 관련 state
  const [modalToggle1, setModalToggle1] = useState(false);
  const [modalRowData1, setModalRowData1] = useState(() =>
    createInitial(TRA_CUSTOM_02_Schema.fields.eduForm)
  );
  const [members, setMembers] = useState([]);
  const [photoPreview1, setPhotoPreview1] = useState(null);
  const [photoPreview2, setPhotoPreview2] = useState(null);
  /** 비신청인「보기」: 안전보건 교육일지 읽기 전용 */
  const [educationDiaryReadOnly, setEducationDiaryReadOnly] = useState(false);
  /** 비신청인「보기」: 자체등록 일지 모달 읽기 전용 */
  const [selfFileModalReadOnly, setSelfFileModalReadOnly] = useState(false);

  /** 세이프온 간편등록용 교육강사 선택 모달 */
  const [instructorMemberModalOpen, setInstructorMemberModalOpen] =
    useState(false);

  // 회의정보 등록팝업안의 참석인원 추가하기 팝업
  /** 결재 상신 팝업 */
  const [approvalModalOpen, setApprovalModalOpen] = useState(false);
  const [approvalTargetRow, setApprovalTargetRow] = useState(null);
  const [approvalIntermediate, setApprovalIntermediate] = useState([]);
  const [approvalFinal, setApprovalFinal] = useState(null);
  const [approvalSignStatus, setApprovalSignStatus] = useState(null);
  const [approvalMemberModalOpen, setApprovalMemberModalOpen] = useState(false);
  const [approvalMemberPickMode, setApprovalMemberPickMode] = useState(null); // 'intermediate' | 'final'

  /** 그리드「결재하기」서명 팝업 */
  const [approverSignModalOpen, setApproverSignModalOpen] = useState(false);
  const [approverSignRow, setApproverSignRow] = useState(null);
  /** 결재 반려 사유 팝업 */
  const [approverRejectModalOpen, setApproverRejectModalOpen] = useState(false);
  const [approverRejectRow, setApproverRejectRow] = useState(null);
  const approverRejectDetailRef = useRef('');
  const approverSignPathRef = useRef('');

  /** 반려 이력 팝업 */
  const [returnHistoryModalOpen, setReturnHistoryModalOpen] = useState(false);
  const [returnHistoryRows, setReturnHistoryRows] = useState([]);

  /** 참석인원 추가 팝업 */
  const [attendeeMemberModalOpen, setAttendeeMemberModalOpen] = useState(false);

  /** 그리드 수정 클릭 시 selfYn===Y 이면 자체 교육 일지 모달용으로 행 전달 */
  const [selfFileEditRowPayload, setSelfFileEditRowPayload] = useState(null);

  /** QR 임시 세션 (저장 전 참석 수집) */
  const [qrModalOpen, setQrModalOpen] = useState(false);
  const [qrSessionId, setQrSessionId] = useState(null);
  const [qrExpireDate, setQrExpireDate] = useState(null);
  const qrSessionIdRef = useRef(null);

  //#endregion

  const ClearQrSession = useCallback(() => {
    setQrSessionId(null);
    qrSessionIdRef.current = null;
    setQrExpireDate(null);
    setQrModalOpen(false);
  }, []);

  useEffect(() => {
    qrSessionIdRef.current = qrSessionId;
  }, [qrSessionId]);

  const convertToEduCodes = (data) => {
    const result = {
      EDU_TYPE: [], // 교육의 구분
      EDU_NM: {}, // 교육명
      EDU_CONTENTS: {}, // 교육 내용
    };

    data.forEach((item) => {
      const group = item.groupCd;
      const code = item.code;
      const name = item.codeNm;

      if (group === 'EDU_GUBUN') {
        result.EDU_TYPE.push({ code, name });
        return;
      }

      if (/^EG_\d{3,4}$/.test(group)) {
        const typeCode = group.replace('EG_', '');

        if (!result.EDU_NM[typeCode]) {
          result.EDU_NM[typeCode] = [];
        }

        result.EDU_NM[typeCode].push({
          code,
          name,
        });

        return;
      }

      if (/^EG_\d{3,4}_\d{3,4}$/.test(group)) {
        const eduNameCode = group;

        if (!result.EDU_CONTENTS[eduNameCode]) {
          result.EDU_CONTENTS[eduNameCode] = [];
        }

        result.EDU_CONTENTS[eduNameCode].push({
          code,
          name,
        });

        return;
      }
    });

    return result;
  };

  const photo1Upload = useFileUpload({
    oldFilePathField: 'eduImageFilePath1',
    newFileNameField: 'eduImageSaveName1',
    getTargetPath: (_item, custCd) => `Education/${custCd}/TRA_CUSTOM_02`,
  });

  const photo2Upload = useFileUpload({
    oldFilePathField: 'eduImageFilePath2',
    newFileNameField: 'eduImageSaveName2',
    getTargetPath: (_item, custCd) => `Education/${custCd}/TRA_CUSTOM_02`,
  });

  const { SaveLogicPreview: SaveLogicSelfFilePreview } = photo1Upload;

  const fixUrlSelfFile = (url) => {
    if (!url || typeof url !== 'string') return '';
    const parts = url.split('/');
    const fileName = parts.pop();
    const encodedFileName = encodeURIComponent(fileName);
    return [...parts, encodedFileName].join('/');
  };

  const DownloadSelfFileLogic = async (_data) => {
    if (!_data) {
      dispatch(
        showSnackbar({
          message: '다운로드할 파일이 없습니다.',
          type: 'warning',
        })
      );
      return;
    }
    const filePath = _data.previewFilePath || _data.filePath;
    if (!filePath) {
      dispatch(
        showSnackbar({ message: '파일 경로가 없습니다.', type: 'warning' })
      );
      return;
    }
    const fileName = _data.fileName || _data.saveName || 'downloaded_file';
    try {
      const params = {
        FileName: fileName,
        Url: fixUrlSelfFile(filePath),
      };
      await Commons.Axios(
        'fileDown',
        Global.file.useUrl + Global.urls.Execute.UrlFileDownload,
        params
      ).then((result) => {
        const contentType = result?.headers?.['content-type'];
        const blobData = result?.data;
        if (!blobData || !contentType) {
          dispatch(
            showSnackbar({
              message: `"${fileName}" 다운로드 응답이 비정상입니다.`,
              type: 'error',
            })
          );
          return;
        }
        const blob = new Blob([blobData], { type: contentType });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
        dispatch(
          showSnackbar({
            message: `"${fileName}" 다운로드 완료`,
            type: 'success',
          })
        );
      });
    } catch (e) {
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    }
  };

  const { handlePartialRefresh } = usePartialRefresh({
    gridRef: gridRef1,
    changedRowData: changedRowData1,
    setChangedRowData: setChangedRowData1,
    setRowData: setRowData1,
    getKeyFromRow: (row) => row.no,
    getKeyFromResult: (result) => result.no,
  });
  // 삭제로직
  const delete1 = useDelete1();
  const delete2 = useDelete2();

  const deleteHandler1 = useDelete({
    gridRef: gridRef1,
    deleteMutation: delete1,
    updateDeleted: setDeletedRowData1,
    updateRowData: setRowData1,
    deletedRowData: deletedRowData1,
    rowData: rowData1,
    setChangedRowData: setChangedRowData1,
  });

  // 수정 시 필요 함수
  const updateCurrentRowData = (fieldName, value, skipValidation = false) => {
    if (!gridRef1.current || currentRowIndexRef.current === null) return;

    const api = gridRef1.current.api;
    const rowNode = api.getDisplayedRowAtIndex(currentRowIndexRef.current);
    if (!rowNode) return;

    const prevData = rowNode.data;
    const updatedRowData = {
      ...prevData,
      [fieldName]: value,
      editYn: 'Y',
    };

    rowNode.setData(updatedRowData);

    if (!Array.isArray(changedRowData1)) return;

    const alreadyChangedIndex = changedRowData1.findIndex(
      (item) => item.no === updatedRowData.no
    );
    const newChangedList = [...changedRowData1];

    if (alreadyChangedIndex > -1) {
      newChangedList[alreadyChangedIndex] = updatedRowData;
    } else {
      newChangedList.push(updatedRowData);
    }
    setChangedRowData1(newChangedList);
  };

  //#region 조회
  const { refetch: SearchCode } = useSearchCode({
    onSuccess: async (rows) => {
      const tree = convertToEduCodes(rows);
      setCodes(tree);
    },
  });
  const { refetch: Search1 } = useSearch1({
    onSuccess: async (rows) => {
      const sanitized = rows.map((row) => ({
        ...row,
        tpmId: resolveTraCustom02TpmId(row),
        selfYn: row.selfYn ?? row.SELF_YN ?? 'N',
        createId: row.createId ?? row.CreateId ?? '',
        finalSignYn: row.finalSignYn ?? row.FinalSignYn ?? 'N',
        midSignYn: row.midSignYn ?? row.MidSignYn ?? 'N',
        finalSignId: row.finalSignId ?? row.FinalSignId ?? '',
        midSignIdsJoined: row.midSignIdsJoined ?? row.MidSignIdsJoined ?? '',
        midSignPathsJoined:
          row.midSignPathsJoined ?? row.MidSignPathsJoined ?? '',
        eduTypeNm: convertHtmlBrToNewLine(row.eduTypeNm),
        eduNmNm: convertHtmlBrToNewLine(row.eduNmNm),
        eduContentsNm: convertHtmlBrToNewLine(row.eduContentsNm),
      }));

      setRowData1(sanitized);
    },
  });

  const { run: Search2, runAsync: Search2Async } = useSearch2({
    onSuccess: (rows) => {
      const mapped = rows.map((item, index) => ({
        tpdId: item?.tpdId ?? item?.TPD_ID ?? '',
        no: item?.no ?? item?.NO ?? index + 1,
        jobType: item?.jobType ?? item?.JOB_TYPE ?? '',
        depNm: item?.depNm ?? item?.DEP_NM ?? '',
        position: item?.position ?? item?.POSITION ?? '',
        rank: item?.rank ?? item?.Rank ?? item?.RANK ?? '',
        tpaUserId: item?.tpaUserId ?? item?.TPA_USER_ID ?? '',
        userNm: item?.userNm ?? item?.USER_NM ?? '',
        remark: item?.remark ?? item?.REMARK ?? '',
        signYn: item?.signYn ?? item?.SIGN_YN ?? item?.SignYn ?? 'N',
        signPath: item?.signPath ?? item?.SIGN_PATH ?? item?.SignPath ?? '',
      }));
      setMembers(mapped);
      return mapped;
    },
  });

  const { runAsync: CreateQrSessionAsync } = useCreateTraCustom02QrSession();
  const { runAsync: PollQrSessionAsync } = useSearchTraCustom02SessionR2();
  const { runAsync: BindQrSessionAsync } = useBindTraCustom02QrSession();

  const mergeQrPollRows = useCallback((rows) => {
    if (!Array.isArray(rows)) return;
    setMembers((prev) => {
      const manual = prev.filter((m) => !m.deleted && !m.fromQr);
      if (rows.length === 0) {
        return manual;
      }
      const qrRows = rows.map((item, index) => ({
        fromQr: true,
        qrDetId: item.tpdId ?? item.TPD_ID ?? `qr_${index}`,
        tpdId: '',
        no: item.no ?? item.NO ?? index + 1,
        jobType: item.jobType ?? item.JOB_TYPE ?? '',
        depNm: '',
        position: '',
        tpaUserId: item.tpaUserId ?? item.TPA_USER_ID ?? '',
        userNm: item.userNm ?? item.USER_NM ?? '',
        remark: item.remark ?? item.REMARK ?? '',
        signYn:
          String(item.remark ?? item.REMARK ?? '').trim() !== '' ? 'Y' : 'N',
        signPath: item.remark ?? item.REMARK ?? '',
      }));
      return [...manual, ...qrRows];
    });
  }, []);

  const LogicQrCreate = async () => {
    if (!props.validateSelection?.()) return;
    if (!modalToggle1) {
      dispatch(
        showSnackbar({
          message: '교육일지 작성 창을 연 상태에서 이용해 주세요.',
          type: 'warning',
        })
      );
      return;
    }
    try {
      const rawTpm = resolveTraCustom02TpmId(modalRowData1);
      const tpmIdForQr = rawTpm && String(rawTpm) !== '0' ? String(rawTpm) : '';

      const res = await CreateQrSessionAsync({
        expireHours: 48,
        search: searchInfo,
        userInfo,
        tpmId: tpmIdForQr,
      });
      const row0 = res?.data?.[0];
      const sid = row0?.sessionId ?? row0?.SessionId;
      const exp = row0?.expireDate ?? row0?.ExpireDate;
      if (!sid) {
        dispatch(
          showSnackbar({
            message: res?.message || 'QR 세션을 만들 수 없습니다.',
            type: 'warning',
          })
        );
        return;
      }
      setQrSessionId(sid);
      qrSessionIdRef.current = sid;
      setQrExpireDate(exp || null);
      setQrModalOpen(true);
    } catch {
      dispatch(
        showSnackbar({
          message: 'QR 세션 생성 중 오류가 발생했습니다.',
          type: 'error',
        })
      );
    }
  };

  useEffect(() => {
    if (!qrModalOpen || !qrSessionId) return undefined;

    const poll = async () => {
      try {
        const rows = await PollQrSessionAsync({ sessionId: qrSessionId });
        mergeQrPollRows(rows);
      } catch {
        /* 폴링 실패는 무시 */
      }
    };

    poll();
    const timer = setInterval(poll, 8000);
    return () => clearInterval(timer);
    // PollQrSessionAsync는 useMutation마다 참조가 바뀌어 의존에 넣으면 setMembers 직후 매번 effect가 재실행되어 API가 폭주함
  }, [qrModalOpen, qrSessionId]);

  //#endregion
  //#region 저장

  const handlePhotoChange = async (event, setPreview, slotIndex) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e) => setPreview(e.target.result);
    reader.readAsDataURL(file);

    try {
      const timestamp = dayjs().format('YYYYMMDDHHmmss');
      const saveName = `${timestamp}_${file.name}`;
      const fileToSave = new File([file], saveName, { type: file.type });

      const uploader = slotIndex === 1 ? photo1Upload : photo2Upload;

      const previewPath = await uploader.SaveLogicPreview(fileToSave);
      if (!previewPath) return;

      setModalRowData1((prev) => {
        const next = { ...prev };

        if (slotIndex === 1) {
          next.eduImageFileName1 = file.name;
          next.eduImageSaveName1 = saveName;
          next.previewFilePath1 = previewPath;
        } else {
          next.eduImageFileName2 = file.name;
          next.eduImageSaveName2 = saveName;
          next.previewFilePath2 = previewPath;
        }

        return next;
      });
    } finally {
      if (event.target) event.target.value = '';
    }
  };

  const finalizeEduImages = async () => {
    let updated = { ...modalRowData1 };
    const custCd = searchInfo?.custCd;
    if (!custCd) return updated;

    const targetBasePath = `Education/${custCd}/TRA_CUSTOM_02`;

    const slots = [
      {
        previewKey: 'previewFilePath1',
        saveNameKey: 'eduImageSaveName1',
        pathKey: 'eduImageFilePath1',
        uploader: photo1Upload,
      },
      {
        previewKey: 'previewFilePath2',
        saveNameKey: 'eduImageSaveName2',
        pathKey: 'eduImageFilePath2',
        uploader: photo2Upload,
      },
    ];

    for (const slot of slots) {
      const previewPath = updated[slot.previewKey];
      const saveName = updated[slot.saveNameKey];

      if (
        !previewPath ||
        !saveName ||
        !String(previewPath).includes('PreviewFiles')
      )
        continue;

      await slot.uploader.SaveLogicFile(
        {
          previewFilePath: previewPath,
          [slot.saveNameKey]: saveName,
          [slot.pathKey]: updated[slot.pathKey] || '',
        },
        custCd
      );

      updated = {
        ...updated,
        [slot.pathKey]: `${targetBasePath}/${saveName}`,
        [slot.previewKey]: '',
      };
    }

    setModalRowData1(updated);
    return updated;
  };

  /**
   * PC사인 서명 캡처 이미지를 PreviewFiles -> 최종 경로로 이동 후,
   * signPath(서명 경로 문자열) 반환
   */
  const SaveLogicPcSign = async (signatureFile) => {
    const custCd = searchInfo?.custCd;
    if (!custCd) return '';
    if (!signatureFile) return '';

    const targetBasePath = `Education/${custCd}/TRA_CUSTOM_02`;

    // 미리보기 업로드 (PreviewFiles 경로 확보)
    const previewPath = await photo1Upload.SaveLogicPreview(signatureFile);
    if (!previewPath) return '';

    const saveName = signatureFile.name || `pc_sign_${Date.now()}.png`;

    await photo1Upload.SaveLogicFile(
      {
        previewFilePath: previewPath,
        eduImageSaveName1: saveName,
        // oldFilePath는 self 모달처럼 비워서 move 단계에서 문제 없게 처리
        eduImageFilePath1: '',
      },
      custCd
    );

    return `${targetBasePath}/${saveName}`;
  };

  /**
   * 신청자(상신자) PC사인 이미지를 업로드 후
   * APPLICANT_SIGN_PATN에 넣을 경로를 반환합니다.
   */
  const SaveLogicApplicantSign = async (signatureFile) => {
    const custCd = searchInfo?.custCd;
    if (!custCd) return '';
    if (!signatureFile) return '';

    const targetBasePath = `Education/${custCd}/TRA_CUSTOM_02`;

    const previewPath = await photo1Upload.SaveLogicPreview(signatureFile);
    if (!previewPath) return '';

    const saveName = signatureFile.name || `applicant_sign_${Date.now()}.png`;

    await photo1Upload.SaveLogicFile(
      {
        previewFilePath: previewPath,
        eduImageSaveName1: saveName,
        eduImageFilePath1: '',
      },
      custCd
    );

    return `${targetBasePath}/${saveName}`;
  };

  /** 중간/최종 결재자 서명 파일 업로드 후 저장 경로 */
  const SaveLogicApproverSign = async (signatureFile) => {
    const custCd = searchInfo?.custCd;
    if (!custCd) return '';
    if (!signatureFile) return '';

    const targetBasePath = `Education/${custCd}/TRA_CUSTOM_02`;

    const previewPath = await photo1Upload.SaveLogicPreview(signatureFile);
    if (!previewPath) return '';

    const saveName = signatureFile.name || `approver_sign_${Date.now()}.png`;

    await photo1Upload.SaveLogicFile(
      {
        previewFilePath: previewPath,
        eduImageSaveName1: saveName,
        eduImageFilePath1: '',
      },
      custCd
    );

    return `${targetBasePath}/${saveName}`;
  };

  const { runAsync: Save1Async } = useSave1();
  const { runAsync: Save2Async } = useSave2();

  const FinalizeSelfFileImage = async (data) => {
    const custCd = searchInfo?.custCd;
    if (!custCd) return null;
    const targetBasePath = `Education/${custCd}/TRA_CUSTOM_02`;
    const previewPath = data.eduImageFilePath1;
    const saveName = data.eduImageSaveName1;
    const fileName = data.eduImageFileName1;
    if (!fileName?.toString().trim() || !saveName?.toString().trim()) {
      return null;
    }
    if (!previewPath?.toString().trim()) {
      return null;
    }
    if (String(previewPath).includes('PreviewFiles')) {
      await photo1Upload.SaveLogicFile(
        {
          previewFilePath: previewPath,
          eduImageSaveName1: saveName,
          // 메인 그리드 업로드와 동일하게 oldFilePath는 비워둬야 합니다.
          // (self 모달은 previewPath를 eduImageFilePath1에 직접 저장하므로, 여기로 oldFilePath가 넘어가면 서버 moveAndReplaceFile에서 에러가 날 수 있습니다.)
          eduImageFilePath1: '',
        },
        custCd
      );
      return {
        selfImageFileName: fileName,
        selfImageSaveName: saveName,
        selfImageFilePath: `${targetBasePath}/${saveName}`,
      };
    }
    return {
      selfImageFileName: fileName,
      selfImageSaveName: saveName,
      selfImageFilePath: previewPath,
    };
  };

  const BuildSelfFileSaveRow = (data, finalized) => ({
    tpmId: data.tpmId || '',
    selfYn: 'Y',
    eduDt: data.eduDt || dayjs().format('YYYY-MM-DD'),
    eduTm: data.eduTm ?? '',
    eduPlace: data.eduPlace ?? '',
    eduManager: data.eduManager ?? '',
    eduTypeCd: '',
    eduNmCd: '',
    eduContentsCd: '',
    eduTypeSelfNm: data.eduTypeNm ?? '',
    eduSelfNm: data.etcEduNm ?? '',
    etcEduNm: '',
    etcEduContents: data.etcEduContents ?? '',
    // 자체등록의 교육내용(EDU_SELF_CONTENTS)
    eduSelfContents: data.etcEduContents ?? '',
    eduTargetMCnt: String(data.eduTargetMCnt ?? '0'),
    eduTargetWCnt: String(data.eduTargetWCnt ?? '0'),
    eduExecMCnt: String(data.eduExecMCnt ?? '0'),
    eduExecWCnt: String(data.eduExecWCnt ?? '0'),
    eduNoExecMCnt: String(data.eduNoExecMCnt ?? '0'),
    eduNoExecWCnt: String(data.eduNoExecWCnt ?? '0'),
    eduNoExecReason1: data.eduNoExecReason1 ?? '',
    eduNoExecReason2: data.eduNoExecReason2 ?? '',
    eduNoExecReason3: data.eduNoExecReason3 ?? '',
    significant: '',
    eduImageFileName1: '',
    eduImageSaveName1: '',
    eduImageFilePath1: '',
    eduImageFileName2: '',
    eduImageSaveName2: '',
    eduImageFilePath2: '',
    selfImageFileName: finalized.selfImageFileName,
    selfImageSaveName: finalized.selfImageSaveName,
    selfImageFilePath: finalized.selfImageFilePath,
  });

  const SaveSelfFileLogic = async (selfFileData) => {
    if (props.validateSelection && !props.validateSelection()) {
      return false;
    }
    const custCd = searchInfo?.custCd;
    if (!custCd) {
      dispatch(
        showSnackbar({
          message: '고객사를 선택해 주세요.',
          type: 'warning',
        })
      );
      return false;
    }
    try {
      const finalized = await FinalizeSelfFileImage(selfFileData);
      if (!finalized) {
        dispatch(
          showSnackbar({
            message: '첨부 파일을 확인해 주세요.',
            type: 'error',
          })
        );
        return false;
      }
      const row = BuildSelfFileSaveRow(selfFileData, finalized);
      const mstRes = await Save1Async({ rows: [row], isEtcEduType: false });
      const list = Array.isArray(mstRes) ? mstRes : mstRes ? [mstRes] : [];
      const first = list?.[0];
      const ok = first?.isSuccess === true || first?.IsSuccess === true;
      if (ok) {
        const tpmRow = first?.data?.[0] ?? first?.Data?.[0];
        const tpmIdFromApi =
          tpmRow?.tpmId ?? tpmRow?.TpmId ?? tpmRow?.TPM_ID ?? '';
        const rowForApproval = {
          ...selfFileData,
          ...row,
          selfYn: 'Y',
          ...(tpmIdFromApi !== '' && tpmIdFromApi != null
            ? { tpmId: String(tpmIdFromApi) }
            : {}),
        };
        const resolvedTpm = resolveTraCustom02TpmId(rowForApproval);

        await Search1();

        if (resolvedTpm && props.validateSelection?.()) {
          setApprovalTargetRow({
            ...rowForApproval,
            tpmId: resolveTraCustom02TpmId(rowForApproval),
          });
          setApprovalIntermediate([]);
          setApprovalFinal(null);
          setApprovalSignStatus(null);
          setApprovalModalOpen(true);
        }

        dispatch(
          showSnackbar({
            message: '자체 교육 일지가 저장되었습니다.',
            type: 'success',
          })
        );
        return true;
      }
      const msg = first?.message || first?.Message || '저장에 실패했습니다.';
      dispatch(
        showSnackbar({
          message: msg,
          type: 'error',
        })
      );
      return false;
    } catch (e) {
      dispatch(
        showSnackbar({
          message: e?.message || '저장 중 오류가 발생했습니다.',
          type: 'error',
        })
      );
      return false;
    }
  };

  const { run: Save1 } = useSave({
    menuId: SCREEN_MENU_ID,
    requiredLabel: '안전보건 교육일지',
    schema: TRA_CUSTOM_02_Schema,

    getChangedRows: () => (modalToggle1 ? [modalRowData1] : []),
    getDeletedRows: () => (!modalToggle1 ? deletedRowData1 : []),

    requestDelete: deleteHandler1.DeleteLogic,

    requestSave: async (rows) => {
      const finalized = await finalizeEduImages();
      const modal = finalized || rows[0];

      const mstRes = await Save1Async({ rows: [modal], isEtcEduType });

      const tpmRow = mstRes?.[0]?.data?.[0];
      const tpmId =
        tpmRow?.tpmId ?? tpmRow?.TpmId ?? tpmRow?.TPM_ID ?? modal?.tpmId;

      const deletedMembers = (members || []).filter(
        (m) => m.deleted && m.tpdId
      );
      if (deletedMembers.length > 0) {
        await delete2.runAsync(deletedMembers);
      }
      const activeMembers = (members || []).filter(
        (m) => !m.deleted && !m.fromQr
      );
      if (activeMembers.length > 0) {
        await Save2Async({ rows: activeMembers, tpmId });
      }

      const sid = qrSessionIdRef.current;
      if (sid && tpmId) {
        try {
          await BindQrSessionAsync({
            sessionId: sid,
            tpmId: String(tpmId),
            userInfo,
          });
          ClearQrSession();
        } catch {
          dispatch(
            showSnackbar({
              message: 'QR 세션을 교육일지에 연결하지 못했습니다.',
              type: 'warning',
            })
          );
        }
      }

      return mstRes;
    },

    onSuccessRefresh: async ({ saveDetailData, changedRows }) => {
      const saveAllOk =
        Array.isArray(saveDetailData) &&
        saveDetailData.length > 0 &&
        saveDetailData.every(
          (r) => r?.isSuccess === true || r?.IsSuccess === true
        );

      let openApprovalAfterSave = false;
      let rowForApproval = null;

      if (saveAllOk && changedRows?.length > 0) {
        const firstRes = saveDetailData[0];
        const tpmRow = firstRes?.data?.[0] ?? firstRes?.Data?.[0];
        const tpmIdFromApi =
          tpmRow?.tpmId ?? tpmRow?.TpmId ?? tpmRow?.TPM_ID ?? '';
        rowForApproval = {
          ...changedRows[0],
          ...(tpmIdFromApi !== '' && tpmIdFromApi != null
            ? { tpmId: String(tpmIdFromApi) }
            : {}),
        };
        const resolved = resolveTraCustom02TpmId(rowForApproval);
        openApprovalAfterSave = Boolean(resolved);
      }

      await Search1();

      if (openApprovalAfterSave && rowForApproval) {
        if (props.validateSelection?.()) {
          setApprovalTargetRow({
            ...rowForApproval,
            tpmId: resolveTraCustom02TpmId(rowForApproval),
          });
          setApprovalModalOpen(true);
        }
      }

      ResetLogic2();
    },
    partialRefresh: ({ saveResult, changedRows }) =>
      handlePartialRefresh({
        saveResult,
        changedRows,
        searchLogic: Search1,
      }),
  });

  const DeletePhoto = async (slotIndex) => {
    const slot =
      slotIndex === 1
        ? {
            fileNameKey: 'eduImageFileName1',
            saveNameKey: 'eduImageSaveName1',
            pathKey: 'eduImageFilePath1',
            previewKey: 'previewFilePath1',
            setPreview: setPhotoPreview1,
            uploader: photo1Upload,
          }
        : {
            fileNameKey: 'eduImageFileName2',
            saveNameKey: 'eduImageSaveName2',
            pathKey: 'eduImageFilePath2',
            previewKey: 'previewFilePath2',
            setPreview: setPhotoPreview2,
            uploader: photo2Upload,
          };

    const previewPath = modalRowData1[slot.previewKey];
    const finalPath = modalRowData1[slot.pathKey];

    if (previewPath) await slot.uploader.DeleteLogicFile(previewPath);
    else if (finalPath) await slot.uploader.DeleteLogicFile(finalPath);

    setModalRowData1((prev) => ({
      ...prev,
      [slot.fileNameKey]: '',
      [slot.saveNameKey]: '',
      [slot.pathKey]: '',
      [slot.previewKey]: '',
    }));
    slot.setPreview(null);
  };

  //#endregion

  //#region 나머지 함수
  const convertHtmlBrToNewLine = (value) => {
    if (!value) return '';

    let text = value.toString();

    text = text.replace(/<\/p>\s*<br\s*\/?>\s*<p[^>]*>/gi, '\n');

    text = text.replace(/<\/p>\s*<p[^>]*>/gi, '\n');

    text = text.replace(/<br\s*\/?>/gi, '\n');

    text = text.replace(/<\/?p[^>]*>/gi, '');

    text = text.replace(/<\/?[a-z][^>]*>/gi, '');

    text = text.replace(/&nbsp;/gi, ' ');

    text = text.replace(/\r\n|\r/g, '\n');

    text = text.replace(/\n{2,}/g, '\n');
    text = text.replace(/^\n+/, '');

    return text.trim();
  };

  const ConvertImageToBase64 = async (url) => {
    try {
      const response = await fetch(url);

      const blob = await response.blob();

      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          resolve(reader.result);
        };

        reader.readAsDataURL(blob);
      });
    } catch (error) {
      console.error('[ConvertImageToBase64] error', error);
      return '';
    }
  };

  const PrintLogic1 = async () => {
    dispatch(showLoading());

    try {
      const baseRow =
        (Array.isArray(selectedRowData1) && selectedRowData1[0]) ||
        modalRowData1;

      if (!baseRow) {
        dispatch(
          showSnackbar({
            message: '인쇄할 교육일지를 선택해주세요.',
            type: 'warning',
          })
        );
        return;
      }

      const selfYn = String(
        baseRow.selfYn ?? baseRow.SELF_YN ?? 'N'
      ).toUpperCase();

      /** 자체등록: TB SELF_IMAGE_FILE_* 컬럼 기준으로 업로드 파일 PDF 미리보기 */
      if (selfYn === 'Y') {
        const filePath = String(
          baseRow.selfImageFilePath ??
            baseRow.SelfImageFilePath ??
            baseRow.SELF_IMAGE_FILE_PATH ??
            ''
        ).trim();
        const fileName = String(
          baseRow.selfImageFileName ??
            baseRow.SelfImageFileName ??
            baseRow.SELF_IMAGE_FILE_NAME ??
            ''
        ).trim();
        const saveName = String(
          baseRow.selfImageSaveName ??
            baseRow.SelfImageSaveName ??
            baseRow.SELF_IMAGE_SAVE_NAME ??
            ''
        ).trim();

        if (!filePath) {
          dispatch(
            showSnackbar({
              message: '등록된 교육일지 파일이 없습니다.',
              type: 'warning',
            })
          );
          return;
        }

        const normalizedFilePath = filePath.startsWith('http')
          ? filePath.replace(Global.file.useUrl + 'files/', '')
          : filePath;

        const fullUrl =
          Global.file.useUrl + 'files/' + Commons.EncodeUrl(normalizedFilePath);

        const nameForExt = fileName || saveName || normalizedFilePath;
        const ext = (nameForExt.split('.').pop() || '').toLowerCase();

        const officeLike = ['hwp', 'doc', 'docx', 'ppt', 'pptx', 'xls', 'xlsx'];
        const previewUrl =
          ext === 'pdf'
            ? fullUrl
            : officeLike.includes(ext)
              ? fullUrl.replace(/\.(hwp|doc|docx|ppt|pptx|xls|xlsx)$/i, '.pdf')
              : fullUrl;

        window.open(previewUrl, '_blank', 'noopener,noreferrer');
        return;
      }

      const baseTpmId = resolveTraCustom02TpmId(baseRow);
      if (!baseTpmId) {
        dispatch(
          showSnackbar({
            message: '인쇄할 교육일지를 선택해주세요.',
            type: 'warning',
          })
        );
        return;
      }

      let eduImg1 = null;
      let eduImg2 = null;

      if (baseRow.eduImageFilePath1 || baseRow.eduImageFilePath2) {
        try {
          const loadBase64 = async (rawPath) => {
            if (!rawPath) return null;
            const imageUrl =
              Global.file.useUrl + 'files/' + Commons.EncodeUrl(rawPath);

            const base64 = await ConvertImageToBase64(imageUrl);

            if (!base64 || base64 === 'data:application/octet-stream;base64,') {
              return null;
            }

            if (base64.startsWith('data:image/')) {
              return base64.replace(/^data:image\/[a-zA-Z0-9.+-]+;base64,/, '');
            }

            return null;
          };

          const img1 = await loadBase64(baseRow.eduImageFilePath1);
          const img2 = await loadBase64(baseRow.eduImageFilePath2);

          eduImg1 = img1;
          eduImg2 = img2;
        } catch (error) {
          console.error('[PrintLogic1 image convert error]', error);
          eduImg1 = null;
          eduImg2 = null;
        }
      }

      const parseCnt = (v) => {
        const n = parseInt(String(v ?? '').replace(/,/g, ''), 10);
        return Number.isFinite(n) ? n : 0;
      };

      const isPrintEtcEdu =
        isEtcEduType || (baseRow.eduTypeNm || '').includes('기타교육');

      const printEduNm = isPrintEtcEdu
        ? convertHtmlBrToNewLine(
            modalRowData1.eduNmCd || baseRow.etcEduNm || baseRow.eduNmNm || ''
          )
        : convertHtmlBrToNewLine(baseRow.eduNmNm);

      const printEduContents = isPrintEtcEdu
        ? convertHtmlBrToNewLine(
            modalRowData1.eduContentsCd ||
              baseRow.etcEduContents ||
              baseRow.eduContentsNm ||
              ''
          )
        : convertHtmlBrToNewLine(baseRow.eduContentsNm);

      let approvalRows = [];
      try {
        const encTpmId = Commons.EncryptAES(String(baseTpmId));
        const apprRes = await Commons.Axios(
          'post',
          Global.base.useUrl +
            Global.urls.Training.getTraCustom02ApprovalStatus,
          null,
          { TpmId: encTpmId }
        );
        const apprPayload = apprRes?.data ?? apprRes;
        approvalRows =
          apprPayload?.Data ?? apprPayload?.data ?? apprPayload?.rows ?? [];
      } catch {
        approvalRows = [];
      }

      const ap0 =
        Array.isArray(approvalRows) && approvalRows.length > 0
          ? approvalRows[0]
          : null;
      const applicantSignPath = String(
        ap0?.ApplicantSignPath ?? ap0?.applicantSignPath ?? ''
      ).trim();
      const finalSignPath = String(
        ap0?.FinalSignPath ?? ap0?.finalSignPath ?? ''
      ).trim();
      const finalSignId = String(
        ap0?.FinalSignId ?? ap0?.finalSignId ?? ''
      ).trim();

      /** 결재란(작성·검토·승인) 하단 날짜 — 열이 좁아 MM/DD만 전달 */
      const formatApprovalBoxDate = (v) => {
        if (v == null || v === '') return '';
        const d = dayjs(v);
        return d.isValid() ? d.format('MM/DD') : String(v).trim();
      };

      /** 상단 작성일자(문서) */
      const formatCreateDateYmd = (v) => {
        if (v == null || v === '') return '';
        const d = dayjs(v);
        return d.isValid() ? d.format('YYYY-MM-DD') : String(v).trim().slice(0, 10);
      };

      const finalSignDt = formatApprovalBoxDate(
        ap0?.FinalSignDate ?? ap0?.finalSignDate ?? ''
      );

      const midOrdered = [];
      const seenMid = new Set();
      for (const r of Array.isArray(approvalRows) ? approvalRows : []) {
        const midId = r?.MidSignId ?? r?.midSignId;
        if (!midId) continue;
        const key = String(midId);
        if (seenMid.has(key)) continue;
        seenMid.add(key);
        midOrdered.push({
          id: key,
          path: String(r?.MidSignPath ?? r?.midSignPath ?? '').trim(),
          signDt: formatApprovalBoxDate(r?.MidSignDate ?? r?.midSignDate),
        });
      }
      const mid1 = midOrdered[0] || { id: '', path: '', signDt: '' };
      const mid2 = midOrdered[1] || { id: '', path: '', signDt: '' };

      const memberNameById = new Map();
      const idsForNames = [mid1.id, mid2.id, finalSignId].filter(
        (x) => x && String(x).trim()
      );
      if (idsForNames.length && searchInfo?.custCd) {
        try {
          const ctx = {
            userInfo,
            search: { ...searchInfo, searchText: '' },
          };
          const memParams = mapParamsBySchema(
            MemberInfoModal_Schema.mapper.search1,
            ctx
          );
          const memRes = await apiRequest(
            'post',
            Global.urls.Member.getMemBasicR1,
            memParams
          );
          const raw = memRes ?? {};
          const memRows = Array.isArray(raw)
            ? raw
            : Array.isArray(raw?.data)
              ? raw.data
              : Array.isArray(raw?.Data)
                ? raw.Data
                : [];
          for (const r of memRows) {
            const id = String(r?.id ?? r?.Id ?? '').trim();
            if (!id) continue;
            const nm = String(r?.name ?? r?.Name ?? '').trim();
            memberNameById.set(id, nm || id);
          }
        } catch {
          // 이름 없으면 ID만 표시
        }
      }
      const resolveNm = (id) => {
        if (!id) return '';
        return memberNameById.get(String(id)) || String(id);
      };

      const createNm = String(
        baseRow.createNm ?? baseRow.CreateNm ?? ''
      ).trim();

      /** 결재란 '작성' 칸 날짜 — 신청서명일만 사용, 없으면 빈값 */
      const draftSignDt = formatApprovalBoxDate(
        ap0?.ApplicantSignDate ?? ap0?.applicantSignDate ?? ''
      );

      /** 참석자 signL / 교육사진 eduImage와 동일: 파일 경로 → base64 본문(접두어 없음) */
      const loadSignBase64ForPrint = async (rawPath) => {
        if (!rawPath) return '';
        try {
          const imageUrl =
            Global.file.useUrl + 'files/' + Commons.EncodeUrl(rawPath);
          const base64 = await ConvertImageToBase64(imageUrl);
          if (!base64 || base64 === 'data:application/octet-stream;base64,') {
            return '';
          }
          if (base64.startsWith('data:image/')) {
            return base64.replace(
              /^data:image\/[a-zA-Z0-9.+-]+;base64,/,
              ''
            );
          }
          return '';
        } catch {
          return '';
        }
      };

      const uniqueApprovalSignPaths = [
        ...new Set(
          [applicantSignPath, mid1.path, mid2.path, finalSignPath]
            .map((p) => String(p || '').trim())
            .filter(Boolean)
        ),
      ];
      const approvalSignBase64ByPath = new Map();
      await Promise.all(
        uniqueApprovalSignPaths.map(async (p) => {
          const b64 = await loadSignBase64ForPrint(p);
          approvalSignBase64ByPath.set(p, b64);
        })
      );

      const pickApprovalB64 = (pathStr) => {
        const p = String(pathStr || '').trim();
        return p ? approvalSignBase64ByPath.get(p) ?? '' : '';
      };

      const draftSignB64 = pickApprovalB64(applicantSignPath);
      const reviewSignB641 = pickApprovalB64(mid1.path);
      const reviewSignB642 = pickApprovalB64(mid2.path);
      const approveSignB64 = pickApprovalB64(finalSignPath);

      const headerData = {
        tpmId: String(baseTpmId || ''),
        custCd: String(searchInfo?.custCd || ''),
        eduDt: baseRow.eduDt ? dayjs(baseRow.eduDt).format('YYYY-MM-DD') : '',
        eduTm: baseRow.eduTm || '',
        eduPlace: convertHtmlBrToNewLine(baseRow.eduPlace),
        eduManager: convertHtmlBrToNewLine(baseRow.eduManager),
        eduTypeCd: baseRow.eduTypeCd || '',
        eduTypeNm: convertHtmlBrToNewLine(baseRow.eduTypeNm),
        eduNmCd: baseRow.eduNmCd || '',
        eduNmNm: printEduNm,
        eduContentsCd: baseRow.eduContentsCd || '',
        eduContentsNm: printEduContents,

        eduTargetMCnt: parseCnt(baseRow.eduTargetMCnt),
        eduTargetWCnt: parseCnt(baseRow.eduTargetWCnt),
        eduTargetCnt: parseCnt(
          baseRow.eduTargetCnt ??
            parseCnt(baseRow.eduTargetMCnt) + parseCnt(baseRow.eduTargetWCnt)
        ),
        eduExecMCnt: parseCnt(baseRow.eduExecMCnt),
        eduExecWCnt: parseCnt(baseRow.eduExecWCnt),
        eduExecCnt: parseCnt(
          baseRow.eduExecCnt ??
            parseCnt(baseRow.eduExecMCnt) + parseCnt(baseRow.eduExecWCnt)
        ),
        eduNoExecMCnt: parseCnt(baseRow.eduNoExecMCnt),
        eduNoExecWCnt: parseCnt(baseRow.eduNoExecWCnt),
        eduNoExecCnt: parseCnt(
          baseRow.eduNoExecCnt ??
            parseCnt(baseRow.eduNoExecMCnt) + parseCnt(baseRow.eduNoExecWCnt)
        ),

        eduNoExecReason1: convertHtmlBrToNewLine(baseRow.eduNoExecReason1),
        eduNoExecReason2: convertHtmlBrToNewLine(baseRow.eduNoExecReason2),
        eduNoExecReason3: convertHtmlBrToNewLine(baseRow.eduNoExecReason3),

        instructorDept: convertHtmlBrToNewLine(
          baseRow.eduInstructorDepNm ?? baseRow.EduInstructorDepNm ?? ''
        ),
        instructorPosition: convertHtmlBrToNewLine(
          baseRow.eduInstructorPosition ?? baseRow.EduInstructorPosition ?? ''
        ),
        instructorNm: convertHtmlBrToNewLine(
          baseRow.eduInstructorNm ?? baseRow.EduInstructorNm ?? ''
        ),
        instructorRemark: '',

        /** 결재란: 작성(신청) — 경로(텍스트) + base64(그림, 참석자 signL·교육사진과 동일) */
        draftSignNm: createNm,
        draftSignPath: applicantSignPath,
        draftSign: draftSignB64,
        draftSignDt,
        /** 검토1·2 — 중간결재자 */
        reviewSignNm1: resolveNm(mid1.id),
        reviewSignPath1: mid1.path,
        reviewSign1: reviewSignB641,
        reviewSignDt1: mid1.signDt || '',
        reviewSignNm2: resolveNm(mid2.id),
        reviewSignPath2: mid2.path,
        reviewSign2: reviewSignB642,
        reviewSignDt2: mid2.signDt || '',
        /** 승인 — 최종결재자 */
        approveSignNm: resolveNm(finalSignId),
        approveSignPath: finalSignPath,
        approveSign: approveSignB64,
        approveSignDt: finalSignDt,

        /** 레거시 4칸 — signPath1~4·sign1~4는 Kendo Picture용 base64 (eduImageFilePath1과 동일) */
        signNm1: createNm,
        signPath1: draftSignB64,
        sign1: draftSignB64,
        signDt1: draftSignDt,
        signNm2: resolveNm(mid1.id),
        signPath2: reviewSignB641,
        sign2: reviewSignB641,
        signDt2: mid1.signDt || '',
        signNm3: resolveNm(mid2.id),
        signPath3: reviewSignB642,
        sign3: reviewSignB642,
        signDt3: mid2.signDt || '',
        signNm4: resolveNm(finalSignId),
        signPath4: approveSignB64,
        sign4: approveSignB64,
        signDt4: finalSignDt,

        eduImageFilePath1: eduImg1 != null ? String(eduImg1) : '',
        eduImageFilePath2: eduImg2 != null ? String(eduImg2) : '',
        significant: convertHtmlBrToNewLine(baseRow.significant),
        createDate: formatCreateDateYmd(
          baseRow.createDate ?? baseRow.CreateDate ?? ''
        ),
        createNm,
      };

      const memberList = (await Search2Async({ tpmId: baseTpmId })) || [];

      const resolveMemberSignPath = (item) => {
        const p = String(
          item?.signPath ?? item?.SignPath ?? item?.SIGN_PATH ?? ''
        ).trim();
        if (p) return p;
        const r = String(
          item?.remark ?? item?.Remark ?? item?.REMARK ?? ''
        ).trim();
        if (r && (r.includes('/') || r.includes('\\'))) return r;
        return '';
      };

      const normalizedMembers = (
        Array.isArray(memberList) ? memberList : []
      ).map((item, index) => ({
        depNm: item?.depNm ?? item?.DepNm ?? item?.DEP_NM ?? '',
        position: item?.position ?? item?.Position ?? item?.POSITION ?? '',
        rank: item?.rank ?? item?.Rank ?? item?.RANK ?? '',
        userNm: item?.userNm ?? item?.UserNm ?? item?.USER_NM ?? '',
        remark: item?.remark ?? item?.Remark ?? item?.REMARK ?? '',
        signPath: resolveMemberSignPath(item),
        no: item?.no ?? item?.NO ?? index + 1,
      }));
      const safeMembers = normalizedMembers.slice(0, 20);
      const leftCount = 10;
      const rightCount = 10;

      /** 참석자명단: 1·3·5…는 왼쪽, 2·4·6…는 오른쪽 열 (최대 20명 → 열당 최대 10행) */
      const leftData = safeMembers.filter((_m, idx) => idx % 2 === 0);
      const rightData = safeMembers.filter((_m, idx) => idx % 2 === 1);
      while (leftData.length < leftCount) {
        leftData.push({
          userNm: '',
          depNm: '',
          position: '',
          rank: '',
          remark: '',
          signPath: '',
        });
      }
      while (rightData.length < rightCount) {
        rightData.push({
          userNm: '',
          depNm: '',
          position: '',
          rank: '',
          remark: '',
          signPath: '',
        });
      }

      const uniqueSignPaths = [
        ...new Set(
          [...leftData, ...rightData]
            .map((m) => String(m?.signPath || '').trim())
            .filter(Boolean)
        ),
      ];
      const signBase64ByPath = new Map();
      await Promise.all(
        uniqueSignPaths.map(async (p) => {
          const b64 = await loadSignBase64ForPrint(p);
          signBase64ByPath.set(p, b64);
        })
      );

      const tableData1 = [];
      for (let i = 0; i < leftCount; i++) {
        const left = leftData[i] || {};
        const pathL = String(left.signPath || '').trim();
        tableData1.push({
          noL: String(2 * i + 1),
          deptNmL: left.depNm || '',
          positionL: left.position || '',
          rankL: left.rank || '',
          userNmL: left.userNm || '',
          remarkL: left.remark || '',
          signPathL: pathL,
          signL: pathL ? (signBase64ByPath.get(pathL) ?? '') : '',
        });
      }

      const tableData2 = [];
      for (let i = 0; i < rightCount; i++) {
        const right = rightData[i] || {};
        const pathR = String(right.signPath || '').trim();
        tableData2.push({
          noR: String(2 * i + 2),
          deptNmR: right.depNm || '',
          positionR: right.position || '',
          rankR: right.rank || '',
          userNmR: right.userNm || '',
          remarkR: right.remark || '',
          signPathR: pathR,
          signR: pathR ? (signBase64ByPath.get(pathR) ?? '') : '',
        });
      }
      const printData = {
        FileName: 'TRA_CUSTOM_02',
        HeaderData: JSON.stringify([headerData]),
        TableData1: JSON.stringify(tableData1),
        TableData2: JSON.stringify(tableData2),
      };

      await Commons.Axios(
        'report',
        Global.base.useUrl + Global.urls.Reports.reports,
        printData
      ).then((response) => {
        const blobUrl = URL.createObjectURL(response.data);
        window.open(blobUrl, '_blank');
      });
    } catch (e) {
      console.log(e);
      dispatch(
        showSnackbar({
          message: e.message,
          type: 'error',
        })
      );
    } finally {
      dispatch(closeLoading());
    }
  };

  const NewYnErrorMsg = () => {
    dispatch(
      showSnackbar({
        message: '데이터 입력중입니다. 저장 후 시도하세요.',
        type: 'warning',
      })
    );
  };

  const handleRowSelection = (rowData, rowIndex) => {
    currentRowIndexRef.current = rowIndex;
    setSelectedRowData1([rowData]);
  };

  const ResetLogic1 = () => {
    setRowData1([]);
    setSelectedRowData1([]);
    setChangedRowData1([]);
    setDeletedRowData1([]);
    currentRowIndexRef.current = null;
    lastCheckedIndexRef.current = null;
    gridRef1?.current?.api?.deselectAll();
  };

  const ResetLogic2 = () => {
    ClearQrSession();
    setEducationDiaryReadOnly(false);
    setModalToggle1(false);
    setModalRowData1(createInitial(TRA_CUSTOM_02_Schema.fields.eduForm));
    setMembers([]);
    setPhotoPreview1(null);
    setPhotoPreview2(null);
  };

  // 이동 버튼 클릭
  const OpenEducationDiaryForEdit = (rowData) => {
    if (!rowData) return;

    ClearQrSession();

    const selfYn = String(
      rowData.selfYn ?? rowData.SELF_YN ?? 'N'
    ).toUpperCase();

    if (selfYn === 'Y') {
      SearchCode();
      setSelfFileModalReadOnly(false);
      setSelfFileEditRowPayload({ ...rowData, selfYn: 'Y' });
      return;
    }

    setEducationDiaryReadOnly(false);

    const normalizedEduTypeCd = rowData.eduTypeCd
      ? rowData.eduTypeCd.replace(/^EG_/, '')
      : '';
    SearchCode();
    setModalRowData1({
      ...INPUTS,
      ...rowData,
      eduTypeCd: normalizedEduTypeCd,
      tpmId: resolveTraCustom02TpmId(rowData),
    });

    const baseFileUrl = Global.file.useUrl + 'files/';
    if (rowData.eduImageFilePath1) {
      const path1 = rowData.eduImageFilePath1.replace(/\\/g, '/');
      setPhotoPreview1(`${baseFileUrl}${path1}`);
    } else {
      setPhotoPreview1(null);
    }

    if (rowData.eduImageFilePath2) {
      const path2 = rowData.eduImageFilePath2.replace(/\\/g, '/');
      setPhotoPreview2(`${baseFileUrl}${path2}`);
    } else {
      setPhotoPreview2(null);
    }
    Search2({ tpmId: resolveTraCustom02TpmId(rowData) });

    setModalToggle1(true);
  };

  const PopupClickEvent2Update = (rowData) => {
    if (!rowData) {
      dispatch(
        showSnackbar({
          message: '데이터가 없습니다.',
          type: 'warning',
        })
      );
      return;
    }

    OpenEducationDiaryForEdit(rowData);
  };

  const PopupClickEvent2View = (rowData) => {
    if (!rowData) {
      dispatch(
        showSnackbar({
          message: '데이터가 없습니다.',
          type: 'warning',
        })
      );
      return;
    }

    ClearQrSession();

    const selfYn = String(
      rowData.selfYn ?? rowData.SELF_YN ?? 'N'
    ).toUpperCase();

    if (selfYn === 'Y') {
      SearchCode();
      setSelfFileModalReadOnly(true);
      setSelfFileEditRowPayload({ ...rowData, selfYn: 'Y' });
      return;
    }

    const normalizedEduTypeCd = rowData.eduTypeCd
      ? rowData.eduTypeCd.replace(/^EG_/, '')
      : '';
    SearchCode();
    setEducationDiaryReadOnly(true);
    setModalRowData1({
      ...INPUTS,
      ...rowData,
      eduTypeCd: normalizedEduTypeCd,
      tpmId: resolveTraCustom02TpmId(rowData),
    });

    const baseFileUrl = Global.file.useUrl + 'files/';
    if (rowData.eduImageFilePath1) {
      const path1 = rowData.eduImageFilePath1.replace(/\\/g, '/');
      setPhotoPreview1(`${baseFileUrl}${path1}`);
    } else {
      setPhotoPreview1(null);
    }

    if (rowData.eduImageFilePath2) {
      const path2 = rowData.eduImageFilePath2.replace(/\\/g, '/');
      setPhotoPreview2(`${baseFileUrl}${path2}`);
    } else {
      setPhotoPreview2(null);
    }
    Search2({ tpmId: resolveTraCustom02TpmId(rowData) });

    setModalToggle1(true);
  };

  const MapMemberToApprover = (row) => {
    if (!row) return null;
    const depNm = [row.depNm1, row.depNm2, row.depNm3, row.depNm4]
      .filter((x) => x && String(x).trim())
      .join(' ');
    return {
      id: row.id,
      name: row.name || '',
      depNm: depNm || '-',
      position: row.position || '',
      rank: row.rank || '',
    };
  };

  const PopupClickEvent2ApprovalRequest = (rowData) => {
    if (!rowData) {
      dispatch(
        showSnackbar({
          message: '데이터가 없습니다.',
          type: 'warning',
        })
      );
      return;
    }

    if (!props.validateSelection?.()) {
      return;
    }

    setApprovalTargetRow({
      ...rowData,
      tpmId: resolveTraCustom02TpmId(rowData),
    });
    setApprovalModalOpen(true);
  };

  const PopupClickEvent2ApproverSign = (rowData) => {
    if (!rowData) {
      dispatch(
        showSnackbar({
          message: '데이터가 없습니다.',
          type: 'warning',
        })
      );
      return;
    }
    if (!props.validateSelection?.()) {
      return;
    }
    setApproverSignRow({
      ...rowData,
      tpmId: resolveTraCustom02TpmId(rowData),
    });
    setApproverSignModalOpen(true);
  };

  const CloseApproverSignModal = () => {
    setApproverSignModalOpen(false);
    setApproverSignRow(null);
  };

  const OpenApproverRejectFromSign = () => {
    const tpmId = resolveTraCustom02TpmId(approverSignRow);
    if (!approverSignRow || !tpmId) {
      dispatch(
        showSnackbar({
          message: '교육일지 정보가 없습니다.',
          type: 'warning',
        })
      );
      return;
    }
    setApproverRejectRow({ ...approverSignRow, tpmId });
    setApproverSignModalOpen(false);
    setApproverSignRow(null);
    setApproverRejectModalOpen(true);
  };

  const CloseApproverRejectModal = () => {
    setApproverRejectModalOpen(false);
    setApproverRejectRow(null);
  };

  const { run: SaveApproverReject } = useSave({
    menuId: SCREEN_MENU_ID,
    requiredLabel: '반려 사유',
    schema: { fields: TRA_CUSTOM_02_Schema.fields.approverRejectForm },
    getChangedRows: () => {
      if (!approverRejectModalOpen) return [];
      const tpmId = resolveTraCustom02TpmId(approverRejectRow);
      console.log('tpmId', tpmId);
      return [
        {
          ...(approverRejectRow || {}),
          tpmId,
          returnDetail: String(approverRejectDetailRef.current ?? ''),
        },
      ];
    },
    requestSave: async (rows) => {
      const row = rows?.[0] ?? null;
      if (!row) return [];
      const res = await saveTraCustom02ApproverReject({ row, userInfo });
      // useSaveN은 saveDetailData 배열을 기대하므로, 형태를 통일
      if (Array.isArray(res)) return res;
      if (res?.data && Array.isArray(res.data)) return res.data;
      return res ? [res] : [];
    },
    onSuccessRefresh: async () => {
      dispatch(
        showSnackbar({
          message: '반려 처리되었습니다.',
          type: 'success',
        })
      );
      await Search1();
      CloseApproverRejectModal();
    },
  });

  const SubmitApproverReject = async (returnDetail) => {
    approverRejectDetailRef.current = String(returnDetail ?? '');
    await SaveApproverReject();
    return true;
  };

  const { run: SaveApproverSign } = useSave({
    menuId: SCREEN_MENU_ID,
    requiredLabel: '결재 서명',
    schema: { fields: TRA_CUSTOM_02_Schema.fields.approverSignForm },
    getChangedRows: () => {
      if (!approverSignModalOpen) return [];
      const tpmId = resolveTraCustom02TpmId(approverSignRow);
      return [
        {
          ...(approverSignRow || {}),
          tpmId,
          signPath: String(approverSignPathRef.current ?? ''),
        },
      ];
    },
    requestSave: async (rows) => {
      const row = rows?.[0] ?? null;
      if (!row) return [];
      const res = await saveTraCustom02ApproverSign({ row, userInfo });
      if (Array.isArray(res)) return res;
      if (res?.data && Array.isArray(res.data)) return res.data;
      return res ? [res] : [];
    },
    onSuccessRefresh: async () => {
      dispatch(
        showSnackbar({
          message: '결재 서명이 저장되었습니다.',
          type: 'success',
        })
      );
      await Search1();
      CloseApproverSignModal();
    },
  });

  const SubmitApproverSign = async (payload) => {
    const tpmId = resolveTraCustom02TpmId(approverSignRow);
    if (!tpmId) {
      dispatch(
        showSnackbar({
          message: '교육일지 정보가 없습니다.',
          type: 'error',
        })
      );
      return false;
    }
    const file = payload?.signatureFile;
    if (!file) {
      dispatch(
        showSnackbar({
          message: '서명 파일이 없습니다.',
          type: 'warning',
        })
      );
      return false;
    }
    const signPath = await SaveLogicApproverSign(file);
    if (!signPath) {
      dispatch(
        showSnackbar({
          message: '서명 저장에 실패했습니다.',
          type: 'error',
        })
      );
      return false;
    }
    approverSignPathRef.current = signPath;
    await SaveApproverSign();
    return true;
  };

  const CloseReturnHistoryModal = () => {
    setReturnHistoryModalOpen(false);
    setReturnHistoryRows([]);
  };

  const PopupClickEvent2ReturnHistory = async (rowData) => {
    const tpmId = resolveTraCustom02TpmId(rowData);
    if (!tpmId) {
      dispatch(
        showSnackbar({
          message: '교육일지 정보가 없습니다.',
          type: 'warning',
        })
      );
      return;
    }
    try {
      const res = await getTraCustom02ReturnHistory({ row: { tpmId } });
      const list = res?.data?.data ?? res?.data?.Data ?? res?.data ?? [];
      setReturnHistoryRows(Array.isArray(list) ? list : []);
      setReturnHistoryModalOpen(true);
    } catch {
      // apiRequest 내부 공통 에러 처리 사용
    }
  };

  const CloseApprovalModal = () => {
    setApprovalModalOpen(false);
    setApprovalTargetRow(null);
    setApprovalIntermediate([]);
    setApprovalFinal(null);
    setApprovalSignStatus(null);
  };

  const approverFallback = (id) => ({
    id: String(id),
    name: String(id),
    depNm: '—',
  });

  /**
   * 결재선에 저장된 user id → GetMemBasicR1 인력 목록과 매칭 (결재자 선택 모달과 동일 API)
   */
  const buildApproversFromMemberList = async (status) => {
    const mids = (status.midSignIdsOrdered || []).slice(0, 2);
    const fid =
      status.finalSignId && String(status.finalSignId).trim()
        ? String(status.finalSignId).trim()
        : '';

    if (!searchInfo?.custCd || (!mids.length && !fid)) {
      return {
        intermediate: mids.map((id) => approverFallback(id)),
        final: fid ? approverFallback(fid) : null,
      };
    }

    try {
      const ctx = {
        userInfo,
        search: { ...searchInfo, searchText: '' },
      };
      const memParams = mapParamsBySchema(
        MemberInfoModal_Schema.mapper.search1,
        ctx
      );
      const memRes = await apiRequest(
        'post',
        Global.urls.Member.getMemBasicR1,
        memParams
      );
      const raw = memRes ?? {};
      const rows = Array.isArray(raw)
        ? raw
        : Array.isArray(raw?.data)
          ? raw.data
          : Array.isArray(raw?.Data)
            ? raw.Data
            : [];

      const norm = (r) => ({
        id: r.id ?? r.Id ?? '',
        name: r.name ?? r.Name ?? '',
        depNm1: r.depNm1 ?? r.DepNm1 ?? '',
        depNm2: r.depNm2 ?? r.DepNm2 ?? '',
        depNm3: r.depNm3 ?? r.DepNm3 ?? '',
        depNm4: r.depNm4 ?? r.DepNm4 ?? '',
        position: r.position ?? r.Position ?? '',
        rank: r.rank ?? r.Rank ?? '',
      });

      const byId = new Map();
      for (const r of rows) {
        const m = norm(r);
        if (m.id !== '' && m.id != null) byId.set(String(m.id), m);
      }

      const toApprover = (id) => {
        const m = byId.get(String(id));
        if (!m) return approverFallback(id);
        const a = MapMemberToApprover(m);
        return a?.id ? a : approverFallback(id);
      };

      return {
        intermediate: mids.map((id) => toApprover(id)),
        final: fid ? toApprover(fid) : null,
      };
    } catch {
      return {
        intermediate: mids.map((id) => approverFallback(id)),
        final: fid ? approverFallback(fid) : null,
      };
    }
  };

  /** 조회 결과로 서명 현황 + 결재선(이름·부서는 인력 API로 보강) */
  const applyApprovalStateFromFetch = async (status) => {
    if (!status) return;
    setApprovalSignStatus(status);
    const line = await buildApproversFromMemberList(status);
    setApprovalIntermediate(line.intermediate);
    setApprovalFinal(line.final);
  };

  // TPM_ID 기준 서명 현황을 DB에서 다시 조회
  const FetchApprovalSignStatus = async (tpmIdValue) => {
    const empty = {
      applicantSigned: false,
      finalSigned: false,
      midSignedById: {},
      midSignPathById: {},
      applicantSignPath: '',
      applicantSignDate: '',
      finalSignPath: '',
      midSignIdsOrdered: [],
      finalSignId: '',
    };

    if (!tpmIdValue) {
      return empty;
    }

    const encTpmId = Commons.EncryptAES(String(tpmIdValue));
    const res = await Commons.Axios(
      'post',
      Global.base.useUrl + Global.urls.Training.getTraCustom02ApprovalStatus,
      null,
      { TpmId: encTpmId }
    );
    const payload = res?.data ?? res;
    const rows = payload?.Data ?? payload?.data ?? [];
    const row0 = Array.isArray(rows) ? rows?.[0] : null;
    const applicantSignPath =
      row0?.ApplicantSignPath ?? row0?.applicantSignPath ?? '';
    const applicantSignDate =
      row0?.ApplicantSignDate ?? row0?.applicantSignDate ?? '';
    const finalSignPath = row0?.FinalSignPath ?? row0?.finalSignPath ?? '';
    const finalSignIdRaw = row0?.FinalSignId ?? row0?.finalSignId ?? '';
    const finalSignId =
      finalSignIdRaw != null && String(finalSignIdRaw).trim() !== ''
        ? String(finalSignIdRaw).trim()
        : '';

    const midSignedById = {};
    const midSignPathById = {};
    const midSignIdsOrdered = [];
    const seenMid = new Set();
    for (const r of Array.isArray(rows) ? rows : []) {
      const midId = r?.MidSignId ?? r?.midSignId;
      if (!midId) continue;
      const key = String(midId);
      if (!seenMid.has(key)) {
        seenMid.add(key);
        midSignIdsOrdered.push(key);
      }
      const rawMidPath = r?.MidSignPath ?? r?.midSignPath;
      const pathStr =
        rawMidPath != null ? String(rawMidPath).trim() : '';
      if (pathStr) {
        midSignPathById[key] = pathStr;
        midSignedById[key] = true;
      } else if (midSignedById[key] !== true) {
        midSignedById[key] = false;
      }
    }

    return {
      applicantSigned: String(applicantSignPath).trim() !== '',
      finalSigned: String(finalSignPath).trim() !== '',
      midSignedById,
      midSignPathById,
      applicantSignPath,
      applicantSignDate,
      finalSignPath,
      midSignIdsOrdered,
      finalSignId,
    };
  };

  // 결재 상신 후(또는 모달 진입 시) DB에 저장된 서명 현황을 조회
  useEffect(() => {
    if (!approvalModalOpen) return;

    const tpmId = resolveTraCustom02TpmId(approvalTargetRow);
    const emptyStatus = {
      applicantSigned: false,
      finalSigned: false,
      midSignedById: {},
      midSignPathById: {},
      applicantSignPath: '',
      applicantSignDate: '',
      finalSignPath: '',
      midSignIdsOrdered: [],
      finalSignId: '',
    };

    if (!tpmId) {
      setApprovalSignStatus(emptyStatus);
      setApprovalIntermediate([]);
      setApprovalFinal(null);
      return;
    }

    let cancelled = false;

    (async () => {
      try {
        const status = await FetchApprovalSignStatus(tpmId);

        if (cancelled) return;
        await applyApprovalStateFromFetch(status);
      } catch {
        if (cancelled) return;
        await applyApprovalStateFromFetch(emptyStatus);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [
    approvalModalOpen,
    approvalTargetRow,
    searchInfo?.custCd,
    userInfo?.userid,
  ]);

  /** 세이프온 간편등록용 교육강사 선택 */
  const OpenInstructorMemberPicker = () => {
    setInstructorMemberModalOpen(true);
  };

  const CloseInstructorMemberPicker = () => {
    setInstructorMemberModalOpen(false);
  };

  const HandleInstructorSelectConfirm = (members) => {
    if (!members?.length) {
      CloseInstructorMemberPicker();
      return;
    }

    const m = MapMemberToApprover(members[0]);
    if (!m?.id) {
      CloseInstructorMemberPicker();
      return;
    }

    setModalRowData1((prev) => ({
      ...prev,
      eduInstructorId: m.id,
      eduInstructorNm: m.name,
      eduInstructorPosition: m.position,
    }));

    CloseInstructorMemberPicker();
  };

  const OpenAttendeeMemberPicker = () => {
    if (!props.validateSelection?.()) return;
    setAttendeeMemberModalOpen(true);
  };

  const CloseAttendeeMemberPicker = () => {
    setAttendeeMemberModalOpen(false);
  };

  const HandleAttendeeSelectConfirm = (selectedRows) => {
    if (!selectedRows?.length) {
      CloseAttendeeMemberPicker();
      return;
    }

    const allWorkers = selectedRows
      .map((row) => MapMemberToApprover(row))
      .filter((w) => w?.id);

    if (!allWorkers.length) {
      CloseAttendeeMemberPicker();
      return;
    }

    const originalMembers = members || [];
    const existingNonDeletedIds = new Set(
      originalMembers
        .filter((m) => !m.deleted && m.tpaUserId)
        .map((m) => m.tpaUserId.toString())
    );

    let duplicateCount = 0;
    allWorkers.forEach((w) => {
      if (existingNonDeletedIds.has(w.id.toString())) duplicateCount += 1;
    });

    const byUserId = (id) =>
      originalMembers.find(
        (m) => m.tpaUserId && m.tpaUserId.toString() === id
      );

    const nextMembers = [...originalMembers];

    allWorkers.forEach((worker) => {
      const id = worker.id ? worker.id.toString() : null;
      if (!id) return;

      const found = byUserId(id);
      if (found) {
        Object.assign(found, {
          deleted: false,
          depNm: worker.depNm || found.depNm,
          position: worker.position || found.position,
          rank: worker.rank || found.rank,
          jobType: worker.position || worker.depNm || found.jobType,
          userNm: worker.name || found.userNm,
          tpaUserId: id,
        });
      }
    });

    const existingIdsAfterRestore = new Set(
      nextMembers
        .filter((m) => m.tpaUserId)
        .map((m) => m.tpaUserId.toString())
    );

    const newMembersFromSelection = allWorkers
      .filter((w) => w.id && !existingIdsAfterRestore.has(w.id.toString()))
      .map((w) => ({
        tpdId: '',
        no: 0,
        depNm: w.depNm || '',
        position: w.position || '',
        rank: w.rank || '',
        jobType: w.position || w.depNm || '',
        tpaUserId: w.id,
        userNm: w.name || '',
        remark: '',
        signYn: 'N',
        signPath: '',
      }));

    const mergedMembers = [...nextMembers, ...newMembersFromSelection].map(
      (m, idx) => ({ ...m, no: idx + 1 })
    );

    if (duplicateCount > 0) {
      dispatch(
        showSnackbar({
          message: `${duplicateCount}명의 중복된 참석자가 제외되었습니다.`,
          type: 'warning',
        })
      );
    }

    setMembers(mergedMembers);
    CloseAttendeeMemberPicker();
  };

  const OpenApprovalMemberPicker = (mode) => {
    setApprovalMemberPickMode(mode);
    setApprovalMemberModalOpen(true);
  };

  const HandleApproverSelectConfirm = (members) => {
    if (!members?.length) {
      setApprovalMemberModalOpen(false);
      return;
    }

    if (approvalMemberPickMode === 'final') {
      const m = MapMemberToApprover(members[0]);
      if (!m?.id) {
        setApprovalMemberModalOpen(false);
        return;
      }
      setApprovalFinal(m);
      setApprovalSignStatus((prev) => {
        if (!prev) return prev;
        const savedFinalId = String(prev.finalSignId ?? '').trim();
        const nextId = String(m.id ?? '').trim();
        if (savedFinalId && nextId && savedFinalId === nextId) {
          return prev;
        }
        return {
          ...prev,
          finalSigned: false,
          finalSignPath: '',
        };
      });
      setApprovalMemberModalOpen(false);
      return;
    }

    const next = [...approvalIntermediate];
    for (const row of members) {
      const m = MapMemberToApprover(row);
      if (!m?.id) continue;
      if (next.length >= 2) break;
      if (next.some((x) => x.id === m.id)) continue;
      next.push(m);
    }
    setApprovalIntermediate(next);
    setApprovalMemberModalOpen(false);
  };

  const RemoveApprovalIntermediate = (index) => {
    setApprovalIntermediate((prev) => prev.filter((_, i) => i !== index));
  };

  const ValidateApprovalBeforeSign = () => {
    if (!approvalFinal) {
      dispatch(
        showSnackbar({
          message: '최종 결재자를 선택해주세요.',
          type: 'warning',
        })
      );
      return false;
    }
    return true;
  };

  const PostApprovalRequest = async ({
    tpmId,
    midSignIds,
    applicantSignPath,
    keepApplicantSign,
  }) => {
    const requestBody = {
      TpmId: Commons.EncryptAES(String(tpmId ?? '')),
      MidSignIdsCsv: Commons.EncryptAES(midSignIds.join(',')),
      FinalSignId: Commons.EncryptAES(String(approvalFinal.id ?? '')),
      ApplicantSignPath: Commons.EncryptAES(applicantSignPath ?? ''),
      KeepApplicantSign: Commons.EncryptAES(keepApplicantSign ? 'Y' : 'N'),
      UserId: userInfo?.userid ?? '',
    };

    await Commons.Axios(
      'post',
      Global.base.useUrl + Global.urls.Training.saveTraCustom02Approval,
      null,
      requestBody
    );
  };

  /** 결재선만 저장 — 기존 신청자 서명·서명일 유지 */
  const SaveApprovalLineOnly = async () => {
    if (!ValidateApprovalBeforeSign()) {
      return false;
    }

    const tpmId = resolveTraCustom02TpmId(approvalTargetRow);
    if (!tpmId) {
      dispatch(
        showSnackbar({
          message: '교육일지 식별자(TPM)가 없어 저장할 수 없습니다.',
          type: 'error',
        })
      );
      return false;
    }

    const existingSignPath =
      approvalSignStatus?.applicantSignPath?.trim?.() || '';
    if (!existingSignPath) {
      dispatch(
        showSnackbar({
          message:
            '저장할 신청자 서명이 없습니다. 재상신으로 서명을 다시 등록해 주세요.',
          type: 'warning',
        })
      );
      return false;
    }

    const midSignIds = (approvalIntermediate || [])
      .map((x) => x?.id)
      .filter(Boolean);

    try {
      await PostApprovalRequest({
        tpmId,
        midSignIds,
        applicantSignPath: existingSignPath,
        keepApplicantSign: true,
      });

      dispatch(
        showSnackbar({
          message: '결재선이 저장되었습니다.',
          type: 'success',
        })
      );

      try {
        const status = await FetchApprovalSignStatus(tpmId);
        await applyApprovalStateFromFetch(status);
      } catch {
        // 저장은 완료된 상태
      }

      await Search1();
      return true;
    } catch (e) {
      dispatch(
        showSnackbar({
          message: e?.message || '결재선 저장 중 오류가 발생했습니다.',
          type: 'error',
        })
      );
      return false;
    }
  };

  const SubmitApprovalRequest = async (payload) => {
    if (!approvalFinal) {
      dispatch(
        showSnackbar({
          message: '최종 결재자를 선택해주세요.',
          type: 'warning',
        })
      );
      return false;
    }
    const { signatureDataUrl, signatureFile } = payload || {};
    if (!signatureDataUrl) {
      dispatch(
        showSnackbar({
          message: '서명을 완료해 주세요.',
          type: 'warning',
        })
      );
      return false;
    }

    if (!signatureFile) {
      dispatch(
        showSnackbar({
          message: '서명 파일이 없습니다.',
          type: 'warning',
        })
      );
      return false;
    }

    const tpmId = resolveTraCustom02TpmId(approvalTargetRow);
    if (!tpmId) {
      dispatch(
        showSnackbar({
          message: '교육일지 식별자(TPM)가 없어 결재 상신을 할 수 없습니다.',
          type: 'error',
        })
      );
      return false;
    }
    const midSignIds = (approvalIntermediate || [])
      .map((x) => x?.id)
      .filter(Boolean);
    const applicantSignPath = await SaveLogicApplicantSign(signatureFile);
    if (!applicantSignPath) {
      dispatch(
        showSnackbar({
          message: '신청인 사인 저장에 실패했습니다.',
          type: 'error',
        })
      );
      return false;
    }

    try {
      await PostApprovalRequest({
        tpmId,
        midSignIds,
        applicantSignPath,
        keepApplicantSign: false,
      });

      const msgId = tpmId || '';
      dispatch(
        showSnackbar({
          message: `결재 ${approvalSignStatus?.applicantSigned ? '재' : ''}상신이 접수되었습니다. (교육일지: ${msgId})`,
          type: 'success',
        })
      );

      try {
        const status = await FetchApprovalSignStatus(tpmId);
        await applyApprovalStateFromFetch(status);
      } catch {
        // 조회 실패여도 상신은 완료된 상태이므로 모달은 닫음
      }

      CloseApprovalModal();
      return true;
    } catch (e) {
      dispatch(
        showSnackbar({
          message: e?.message || '결재 상신 처리 중 오류가 발생했습니다.',
          type: 'error',
        })
      );
      return false;
    }
  };

  const eduCategoryOptions = (codes.EDU_TYPE || []).map((item) => ({
    value: item.code,
    label: convertHtmlBrToNewLine(item.name || ''),
  }));

  const selectedEduType = (codes.EDU_TYPE || []).find(
    (item) => item.code === modalRowData1.eduTypeCd
  );
  const selectedEduTypeName = selectedEduType
    ? convertHtmlBrToNewLine(selectedEduType.name || '')
    : '';
  const isEtcEduType = selectedEduTypeName.includes('기타교육');

  let eduNameOptions = [];
  if (isEtcEduType) {
    const allEduNmArrays = Object.values(codes.EDU_NM || {});
    eduNameOptions = allEduNmArrays.flat().map((item) => ({
      value: item.code,
      label: convertHtmlBrToNewLine(item.name || ''),
    }));
  } else if (codes.EDU_NM?.[modalRowData1.eduTypeCd]) {
    eduNameOptions = codes.EDU_NM[modalRowData1.eduTypeCd].map((item) => ({
      value: item.code,
      label: convertHtmlBrToNewLine(item.name || ''),
    }));
  }

  // 교육 내용 옵션
  let eduContentOptions = [];
  if (isEtcEduType) {
    const allEduContentsArrays = Object.values(codes.EDU_CONTENTS || {});
    eduContentOptions = allEduContentsArrays.flat().map((item) => ({
      value: item.code,
      label: convertHtmlBrToNewLine(item.name || ''),
    }));
  } else if (codes.EDU_CONTENTS?.[modalRowData1.eduNmCd]) {
    eduContentOptions = codes.EDU_CONTENTS[modalRowData1.eduNmCd].map(
      (item) => ({
        value: item.code,
        label: convertHtmlBrToNewLine(item.name || ''),
      })
    );
  }

  //#endregion

  return (
    <div className="wrap">
      <TRA_CUSTOM_02_ApproverSelectModal
        open={instructorMemberModalOpen}
        onClose={CloseInstructorMemberPicker}
        onConfirm={HandleInstructorSelectConfirm}
        mode="final"
        maxCount={1}
        excludeMemberIds={[]}
      />
      <TRA_CUSTOM_02_ApproverSelectModal
        open={attendeeMemberModalOpen}
        onClose={CloseAttendeeMemberPicker}
        onConfirm={HandleAttendeeSelectConfirm}
        mode="attendee"
        excludeMemberIds={(members || [])
          .filter((m) => !m.deleted && m.tpaUserId)
          .map((m) => String(m.tpaUserId))}
      />
      <TRA_CUSTOM_02_ApproverSelectModal
        open={approvalMemberModalOpen}
        onClose={() => setApprovalMemberModalOpen(false)}
        onConfirm={HandleApproverSelectConfirm}
        mode={approvalMemberPickMode === 'final' ? 'final' : 'intermediate'}
        maxCount={
          approvalMemberPickMode === 'final'
            ? 1
            : Math.max(0, 2 - approvalIntermediate.length)
        }
        excludeMemberIds={[
          String(
            Commons.DecryptoAES(userInfo?.userid ?? userInfo?.userId ?? '') ??
              ''
          ).trim(),
          approvalTargetRow?.createId ?? approvalTargetRow?.CreateId ?? '',
          ...(approvalMemberPickMode === 'final'
            ? []
            : approvalIntermediate.map((x) => x.id).filter(Boolean)),
        ]
          .map((id) => (id != null ? String(id).trim() : ''))
          .filter(Boolean)}
      />
      <TRA_CUSTOM_02
        gridId1={'grid1'}
        navigate={navigate}
        userInfo={userInfo}
        lanInfo={lanInfo}
        rowData1={rowData1}
        setRowData1={setRowData1}
        selectedRowData1={selectedRowData1}
        setSelectedRowData1={setSelectedRowData1}
        changedRowData1={changedRowData1}
        setChangedRowData1={setChangedRowData1}
        filterClick2={props.filterClick2}
        setFilterClick2={props.setFilterClick2}
        searchClick2={props.searchClick2}
        setSearchClick2={props.setSearchClick2}
        addClick2={props.addClick2}
        setAddClick2={props.setAddClick2}
        saveClick2={props.saveClick2}
        setSaveClick2={props.setSaveClick2}
        deleteClick2={props.deleteClick2}
        setDeleteClick2={props.setDeleteClick2}
        printClick2={props.printClick2}
        setPrintClick2={props.setPrintClick2}
        gridRef={gridRef1}
        selectedRowNosRef={selectedRowNosRef}
        lastCheckedIndexRef={lastCheckedIndexRef}
        deletedRowData1={deletedRowData1}
        dispatch={dispatch}
        showSnackbar={showSnackbar}
        // 모달 관련 props
        modalToggle1={modalToggle1}
        setModalToggle1={setModalToggle1}
        educationDiaryReadOnly={educationDiaryReadOnly}
        setEducationDiaryReadOnly={setEducationDiaryReadOnly}
        selfFileModalReadOnly={selfFileModalReadOnly}
        setSelfFileModalReadOnly={setSelfFileModalReadOnly}
        modalRowData1={modalRowData1}
        setModalRowData1={setModalRowData1}
        codes={codes}
        eduCategoryOptions={eduCategoryOptions}
        eduNameOptions={eduNameOptions}
        eduContentOptions={eduContentOptions}
        isEtcEduType={isEtcEduType}
        INPUTS={INPUTS}
        setMembers={setMembers}
        members={members}
        photoPreview1={photoPreview1}
        setPhotoPreview1={setPhotoPreview1}
        photoPreview2={photoPreview2}
        setPhotoPreview2={setPhotoPreview2}
        // 함수
        validateSelection={props.validateSelection}
        ResetLogic1={ResetLogic1}
        ResetLogic2={ResetLogic2}
        SearchLogic1={Search1}
        SaveLogic1={Save1}
        PrintLogic1={PrintLogic1}
        NewYnErrorMsg={NewYnErrorMsg}
        handleRowSelection={handleRowSelection}
        RestoreRow1={deleteHandler1.RestoreRow}
        MarkedForDeletion1={deleteHandler1.MarkedForDeletion}
        updateCurrentRowData={updateCurrentRowData}
        DeleteNewRow1={deleteHandler1.DeleteNewRow}
        PopupClickEvent2Update={PopupClickEvent2Update}
        PopupClickEvent2View={PopupClickEvent2View}
        PopupClickEvent2ApprovalRequest={PopupClickEvent2ApprovalRequest}
        PopupClickEvent2ApproverSign={PopupClickEvent2ApproverSign}
        PopupClickEvent2ReturnHistory={PopupClickEvent2ReturnHistory}
        approverSignModalOpen={approverSignModalOpen}
        CloseApproverSignModal={CloseApproverSignModal}
        SubmitApproverSign={SubmitApproverSign}
        OpenApproverRejectFromSign={OpenApproverRejectFromSign}
        approverRejectModalOpen={approverRejectModalOpen}
        CloseApproverRejectModal={CloseApproverRejectModal}
        SubmitApproverReject={SubmitApproverReject}
        returnHistoryModalOpen={returnHistoryModalOpen}
        CloseReturnHistoryModal={CloseReturnHistoryModal}
        returnHistoryRows={returnHistoryRows}
        approvalModalOpen={approvalModalOpen}
        approvalIntermediate={approvalIntermediate}
        approvalFinal={approvalFinal}
        approvalSignStatus={approvalSignStatus}
        CloseApprovalModal={CloseApprovalModal}
        RemoveApprovalIntermediate={RemoveApprovalIntermediate}
        OpenApprovalMemberPicker={OpenApprovalMemberPicker}
        OpenInstructorMemberPicker={OpenInstructorMemberPicker}
        OpenAttendeeMemberPicker={OpenAttendeeMemberPicker}
        SubmitApprovalRequest={SubmitApprovalRequest}
        SaveApprovalLineOnly={SaveApprovalLineOnly}
        ValidateApprovalBeforeSign={ValidateApprovalBeforeSign}
        handlePhotoChange={handlePhotoChange}
        DeletePhoto={DeletePhoto}
        LogicQrCreate={LogicQrCreate}
        ClearQrSession={ClearQrSession}
        SaveLogicSelfFilePreview={SaveLogicSelfFilePreview}
        DownloadSelfFileLogic={DownloadSelfFileLogic}
        selfFileEditRowPayload={selfFileEditRowPayload}
        setSelfFileEditRowPayload={setSelfFileEditRowPayload}
        SaveLogicSelfFile={SaveSelfFileLogic}
        SaveLogicPcSign={SaveLogicPcSign}
      />
      <TRA_CUSTOM_02_QrModal
        open={qrModalOpen}
        onClose={() => setQrModalOpen(false)}
        sessionId={qrSessionId}
        expireDate={qrExpireDate}
      />
    </div>
  );
}

export default TRA_CUSTOM_02F;
